define(['../validation'], function(validation) {
    'use strict';
    validation.addCustomValidationRule('integer', function(val, options) {
        return val % 1 === 0;
    });
});
